<template>
  <div>
    <fccProvasEspeciais
      :provas-especiais="provasEspeciais"
      class="mb-3"
      @importar="importarProvasEspeciais"
      @excluir="excluirProvasEspeciais"
    />
    <fccCondicoesEspeciais
      :condicoes-especiais="condicoesEspeciais"
      class="mb-3"
      @importar="importarCondicoesEspeciais"
      @excluir="excluirCondicoesEspeciais"
    />
    <fccLocalDeProvaStatus :etapa="etapa" />
  </div>
</template>
<script>
import axios from 'axios'
import store from '../../../../store'
import fccProvasEspeciais from './fccProvasEspeciais.vue'
import fccCondicoesEspeciais from './fccCondicoesEspeciais.vue'
import fccLocalDeProvaStatus from '../fccLocalDeProvaStatus.vue'
import { TP_ETAPA } from '../constantes'

export default {
  components: { fccProvasEspeciais, fccCondicoesEspeciais, fccLocalDeProvaStatus },
  data() {
    return {
      provasEspeciais: [],
      condicoesEspeciais: []
    }
  },
  computed: {
    configuracao() {
      return store.state.localDeProva.configuracao
    },
    idLocalConfig() {
      return this.configuracao.idlocalconfig
    },
    etapa() {
      return TP_ETAPA.SOLICITACAO_ESPECIAL
    }
  },
  created() {
    this.carregaTexto(this.codeMensagem('C01'))
    this.listarProvasEspeciais().then(this.listarCondicoesEspeciais).then(this.codeMensagem)
  },
  methods: {
    listarProvasEspeciais() {
      return new Promise((resolve) => {
        axios
          .get(
            store.state.baseUrlLocalDeProva +
              `LocalExameProvaEspecial/ListaLocalExameProvaEspecial/${this.idLocalConfig}`,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(({ data }) => {
            this.provasEspeciais = data
            resolve()
          })
          .catch(this.setErrorSystem)
      })
    },
    listarCondicoesEspeciais() {
      return new Promise((resolve) => {
        axios
          .get(
            store.state.baseUrlLocalDeProva +
              `LocalExameProvaEspecial/ListaImportacaoCondicaoEspecial/${this.idLocalConfig}`,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(({ data }) => {
            this.condicoesEspeciais = data
            resolve()
          })
          .catch(this.setErrorSystem)
      })
    },
    importarProvasEspeciais() {
      this.callConfirm(`Tem certeza que deseja importar?`, '').then(() => {
        const payload = {
          idLocalConfig: this.idLocalConfig,
          cdFuncionario: this.dadosUserSession.usuCdFuncionario
        }

        this.carregaTexto(this.codeMensagem('C01'))
        axios
          .post(
            store.state.baseUrlLocalDeProva + `LocalExameProvaEspecial/ImportacaoProvaEspecial`,
            payload,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.listarProvasEspeciais().then(this.carregaTexto)
          })
          .catch(this.setErrorSystem)
      })
    },
    excluirProvasEspeciais() {
      this.callConfirm(`Tem certeza que deseja excluir?`, '').then(() => {
        const data = {
          idLocalConfig: this.idLocalConfig,
          cdFuncionario: this.dadosUserSession.usuCdFuncionario
        }

        this.carregaTexto(this.codeMensagem('C01'))
        axios
          .delete(
            store.state.baseUrlLocalDeProva + `LocalExameProvaEspecial/DeleteProvaEspecial`,
            { data },
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.listarProvasEspeciais().then(this.carregaTexto)
          })
          .catch(this.setErrorSystem)
      })
    },
    importarCondicoesEspeciais() {
      this.callConfirm(`Tem certeza que deseja importar?`, '').then(() => {
        const payload = {
          idLocalConfig: this.idLocalConfig,
          cdFuncionario: this.dadosUserSession.usuCdFuncionario
        }

        this.carregaTexto(this.codeMensagem('C01'))
        axios
          .post(
            store.state.baseUrlLocalDeProva + `LocalExameProvaEspecial/ImportacaoCondicaoEspecial`,
            payload,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.listarCondicoesEspeciais().then(this.carregaTexto)
          })
          .catch(this.setErrorSystem)
      })
    },
    excluirCondicoesEspeciais() {
      this.callConfirm(`Tem certeza que deseja excluir?`, '').then(() => {
        const data = {
          idLocalConfig: this.idLocalConfig,
          cdFuncionario: this.dadosUserSession.usuCdFuncionario
        }

        this.carregaTexto(this.codeMensagem('C01'))
        axios
          .delete(
            store.state.baseUrlLocalDeProva + `LocalExameProvaEspecial/DeleteCondicaoEspecial`,
            { data },
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.listarCondicoesEspeciais().then(this.carregaTexto)
          })
          .catch(this.setErrorSystem)
      })
    }
  }
}
</script>